const categories=new Set(['newly-arrived','collectibles','luxury','auctions','discoveries','pokemon','one-piece','other-tcg','art-designer-objects','figures','memorabilia','books-publications','event-exclusives','numbered-editions','watches','handbags','jewellery','accessories','writing-instruments','other-luxury-objects','new-notable']);
export function parseSearchQuery(value='') {
  const text=String(value).slice(0,1000).trim();
  const match=text.match(/^tag:cova-([a-z-]+)(?: AND \((.*)\))?$/s);
  if(match && categories.has(match[1]))return {category:match[1],keyword:match[2]??''};
  return {category:'',keyword:text};
}
export function buildSearchQuery({category='',keyword=''}) {
  const text=String(keyword).slice(0,250).trim();
  const selected=categories.has(category)?category:'';
  return selected?`tag:cova-${selected}${text?` AND (${text})`:''}`:text;
}
export function categorySearchUrl(base,state,category) {
  const url=new URL(base,'https://cova.invalid');
  url.search='';
  const query=buildSearchQuery({...state,category:state.category===category?'':category});
  if(query){url.searchParams.set('type','product');url.searchParams.set('q',query);}
  // A double-slash path would become a protocol-relative external link.
  const path=url.pathname.replace(/^\/{2,}/,'/');
  return `${path}${url.search}`;
}
if(typeof document!=='undefined') {
  for(const root of document.querySelectorAll('[data-cova-search]')) {
    const form=root.querySelector('form[role="search"]');
    const input=form?.querySelector('[name="q"]');
    if(!input)continue;
    const state=parseSearchQuery(input.value);
    input.value=state.keyword;
    const query=document.createElement('input');query.type='hidden';query.name='q';form.append(query);
    input.removeAttribute('name');
    form.addEventListener('submit',()=>{query.value=buildSearchQuery({...state,keyword:input.value});});
    for(const link of root.querySelectorAll('[data-cova-category]')) {
      const category=link.dataset.covaCategory;
      link.href=categorySearchUrl(form.action,state,category);
      if(state.category===category)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');
      // Preserve text that has been entered even before the Search button is used.
      input.addEventListener('input',()=>{link.href=categorySearchUrl(form.action,{...state,keyword:input.value},category);});
    }
    const summary=root.querySelector('[data-cova-query-label]');
    const categoryLabel=state.category?(root.dataset.covaCategoryLabel||state.category.replaceAll('-',' ')):'';
    if(summary)summary.textContent=[state.keyword,categoryLabel].filter(Boolean).join(' · ');
  }
}
